import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import LogoGlitch from '../layout/LogoGlitch';
import Default from './Default';

export default class About extends Default {
   
//==================================================================================================================
//          CONSTRUCTOR
//==================================================================================================================

  constructor() {
    super();
  }

  beforeShow() {
    super.beforeShow();
    LogoGlitch.goTop();
    LogoGlitch.showSmile();
    LogoGlitch.start();
  }

  afterHide() {
    LogoGlitch.stop();
    super.afterHide();
  }
}

ControllerPage._addPage("page-about", About)
